var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContactEmailImg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 116,
  height: 116,
  viewBox: "0 0 116 116"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 42.674h24.894V0H0Z",
  "data-name": "Path 653"
})))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 58,
  r: 58,
  fill: "#f0f0f0",
  "data-name": "Ellipse 9"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1094"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  "data-name": "Group 1093",
  transform: "translate(42.808 34.532)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1091"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#7654fd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.8,
  d: "M20.448.889h-16A3.556 3.556 0 0 0 .892 4.445v33.784a3.556 3.556 0 0 0 3.553 3.56h16a3.556 3.556 0 0 0 3.559-3.56V4.445A3.556 3.556 0 0 0 20.448.889m3.556 33.784H.889M24.004 8.001H.889m8.89-3.556h5.335m-2.668 19.559a2.667 2.667 0 0 0 2.668-2.667 2.667 2.667 0 0 0-2.668-2.668 2.667 2.667 0 0 0-2.667 2.667 2.667 2.667 0 0 0 2.667 2.668m2.668-2.667v1.334a2.223 2.223 0 0 0 4.446 0c0-5.494-3.255-8.357-6.936-8.445a7.1 7.1 0 0 0-3.17.647 7.1 7.1 0 0 0-2.557 1.986 7.1 7.1 0 0 0-1.411 2.913 7.1 7.1 0 0 0 .026 3.237 7.1 7.1 0 0 0 1.857 3.407 7.1 7.1 0 0 0 3.369 1.926 7.3 7.3 0 0 0 3.556 0",
  "data-name": "Path 651"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1092"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#7654fd",
  strokeWidth: 1.8,
  d: "M12.446 38.674a.445.445 0 0 1-.445-.445.444.444 0 0 1 .445-.444m0 .889a.445.445 0 0 0 .445-.445.444.444 0 0 0-.445-.444",
  "data-name": "Path 652"
}))))));
export default SvgContactEmailImg;